import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { angleLeft } from 'react-icons-kit/fa/angleLeft';
import { angleRight } from 'react-icons-kit/fa/angleRight';
import { angleDoubleLeft } from 'react-icons-kit/fa/angleDoubleLeft';
import { angleDoubleRight } from 'react-icons-kit/fa/angleDoubleRight';


import ActionButton from 'components/ActionButton/ActionButton';

import './Pagination.css';

class Pagination extends Component {

  render() {
    const { t, activePage, total, handlePageChange, rows } = this.props;
    const totalPages = Math.ceil(total / rows);

    return (
      <table className='paginationContainer'>
        <tbody>
          <tr>
            <td>
              <ActionButton id='pagFirstPage' icon={angleDoubleLeft} size={'24px'} color={'#006699'} tooltip={'Primera página'}
                disabled={activePage === 0} onClick={activePage > 0 ? handlePageChange.bind(null, 0) : undefined} />
            </td>
            <td>
              <ActionButton id='pagPrevPage' icon={angleLeft} size={'24px'} color={'#006699'} disabled={activePage - 1 < 0}
                onClick={activePage - 1 >= 0 ? handlePageChange.bind(null, activePage - 1) : undefined} tooltip={'Página anterior'} />
            </td>
            <td className='paginationCell'>{(activePage + 1) + t('pagination.of') + (totalPages)}</td>
            <td>
              <ActionButton id='pagNextPage' icon={angleRight} size={'24px'} color={'#006699'} disabled={activePage + 1 > totalPages - 1}
                onClick={activePage + 1 <= totalPages - 1 ? handlePageChange.bind(null, activePage + 1) : undefined} tooltip={'Siguiente página'} />
            </td>
            <td>
              <ActionButton id='pagLastPage' icon={angleDoubleRight} size={'24px'} color={'#006699'} disabled={activePage === totalPages - 1}
                onClick={activePage < totalPages - 1 ? handlePageChange.bind(null, totalPages - 1) : undefined}  tooltip={'Última página'} />
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}

export default translate()(Pagination);
